import { productBus } from "@/event/product/productBus";
import { openStatesHappy } from "@/happyTheme/event/product/openStatesHappy";
import { selectOptionsListHappy } from "@/happyTheme/event/product/selectOptionsListHappy";
import type { Option, Product } from "@/storage/products";
import { nextTick, ref } from "vue";
import { getEmptySelectedValuesHappy } from "./modal/getEmptySelectedValuesHappy";
import { relatedGroupBus } from "@/event/product/relatedGroupeBus";
import { messageErrorSelectOptionHappy, messageErrorSelectOptionHappyEmpty } from "@/happyTheme/event/product/messageErrorSelectOptionHappy";
import { visibleOptionsHappy } from "@/happyTheme/event/product/visibleOptionHappy";
import { forceSelectOptionHappy } from "@/happyTheme/event/product/forceSelectOptionHappy";

const idTimeOutRadio = ref<ReturnType<typeof setTimeout> | number>(0)
const idTimeOutCheckbox = ref<ReturnType<typeof setTimeout> | number>(0)

export async function validateOptionValueHappy(index: number, option: Option) {
    if (idTimeOutCheckbox.value !== 0) clearTimeout(idTimeOutCheckbox.value)
    if (idTimeOutRadio.value !== 0) clearTimeout(idTimeOutRadio.value)
    if (!productBus.value) return

    const productOption: Option[] = productBus.value.options
    const freeOptionCount = option.free_option_count
    const maxOptionCount = option.max_option_count
    const required = option.required
    const type = option.type
    const radioOptionSelected = selectOptionsListHappy.value[option.option_id]?.selected_values?.radio_option?.option_value_id
    const minimumFreeSelected = selectOptionsListHappy.value[option.option_id]?.selected_values?.checkbox_option.option_value_free.length
    const minimumPaidSelected = selectOptionsListHappy.value[option.option_id]?.selected_values?.checkbox_option.option_value_paid.length

    if (
        !productOption ||
        !openStatesHappy.value ||
        !Array.isArray(productOption)
    ) {
        return;
    }

    if (type === "radio" &&
        required &&
        !radioOptionSelected
    ) {
        messageErrorSelectOptionHappy.value[index] = {
            message: "Veuillez sélectionner une option",
            type: 'error'
        }
        idTimeOutRadio.value = setTimeout(() => {
            messageErrorSelectOptionHappy.value[index] = messageErrorSelectOptionHappyEmpty
        }, 3000)

        return;
    }

    if (idTimeOutRadio.value !== 0) {
        messageErrorSelectOptionHappy.value[index] = messageErrorSelectOptionHappyEmpty
        clearTimeout(idTimeOutRadio.value)
        idTimeOutRadio.value = 0;
    }

    if ((type === "checkbox" || type === "select") && required) {
        if (freeOptionCount === 0 && maxOptionCount === 0 && minimumPaidSelected < 1) {
            messageErrorSelectOptionHappy.value[index] = {
                message: "Sélectionner une option",
                type: 'error'
            }

            idTimeOutCheckbox.value = setTimeout(() => {
                messageErrorSelectOptionHappy.value[index] = messageErrorSelectOptionHappyEmpty
            }, 3000)
            return
        }

        if (freeOptionCount !== 0 && maxOptionCount === 0) {
            if (minimumFreeSelected === 0 && minimumPaidSelected === 0) {
                messageErrorSelectOptionHappy.value[index] = {
                    message: `Vous devez sélectionner minimum une options`,
                    type: 'error'
                }
                forceSelectOptionHappy.value = false
                idTimeOutCheckbox.value = setTimeout(() => {
                    messageErrorSelectOptionHappy.value[index] = messageErrorSelectOptionHappyEmpty
                }, 3000)
                return
            }
        }

        if (freeOptionCount !== 0 && maxOptionCount !== 0) {
            if (minimumFreeSelected === 0 && minimumPaidSelected === 0) {
                messageErrorSelectOptionHappy.value[index] = {
                    message: `Vous devez sélectionner minimum une options`,
                    type: 'error'
                }
                forceSelectOptionHappy.value = false
                idTimeOutCheckbox.value = setTimeout(() => {
                    messageErrorSelectOptionHappy.value[index] = messageErrorSelectOptionHappyEmpty

                }, 3000)
                return
            }
        }

        if (freeOptionCount === 0 && maxOptionCount !== 0) {
            if (minimumPaidSelected === 0) {
                messageErrorSelectOptionHappy.value[index] = {
                    message: `Vous devez sélectionner minimum une options`,
                    type: 'error'
                }
                forceSelectOptionHappy.value = false
                idTimeOutCheckbox.value = setTimeout(() => {
                    messageErrorSelectOptionHappy.value[index] = messageErrorSelectOptionHappyEmpty

                }, 3000)
                return
            }
        }


        messageErrorSelectOptionHappy.value[index] = messageErrorSelectOptionHappyEmpty

    }

    forceSelectOptionHappy.value = false
    scrollToNextOption(productOption, index);
}

async function scrollToNextOption(productOption: Option[], index: number,) {
    let goodIndex = index + 1;

    const optionsLength = productOption.length

    if (goodIndex >= optionsLength) {
        openStatesHappy.value[index] = false;
        return
    }

    const nextOption = productOption[goodIndex];

    if (
        nextOption &&
        !selectOptionsListHappy.value[nextOption.option_id]
    ) {
        selectOptionsListHappy.value[nextOption.option_id] = getEmptySelectedValuesHappy(nextOption);
    }

    visibleOptionsHappy.value.splice(index, 1, false)
    openStatesHappy.value[index] = false;

    let element = document.getElementById(nextOption.option_id.toString());
    const container = document.getElementById("modal-body-product-selected-happy");

    if (element?.classList.contains('hidden')) {
        goodIndex++;
        element = document.getElementById(productOption[goodIndex]?.option_id.toString());
        selectOptionsListHappy.value[productOption[goodIndex]?.option_id] = getEmptySelectedValuesHappy(nextOption);
    }

    visibleOptionsHappy.value.splice(index, 1, false)
    openStatesHappy.value[index] = false

    visibleOptionsHappy.value.splice(goodIndex, 1, true)
    openStatesHappy.value[goodIndex] = true

    await nextTick();

    if (!element || !container) return

    const viewportHeight = window.innerHeight
    const viewportCenter = viewportHeight / 2
    const elementRect = element.getBoundingClientRect();
    const elementHeight = elementRect.height;
    const elementCenter = elementRect.top + elementRect.height / 2;

    const distanceToScroll = elementCenter - viewportCenter;

    container.scrollTo({
        top: container.scrollTop + distanceToScroll,
        behavior: 'smooth'
    });
    await nextTick();
}